module.exports = __webpack_public_path__ + "img/person-running.7d820249.svg";